/*
 * @Author: YuanYuan
 * @Date: 2025-01-21 11:28:11
 * @LastEditTime: 2025-06-27 14:18:05
 * @Description: 用量查询常量定义
 */
import i18n from '@/i18n'
import Bandwidth from '@/views/usage/Bandwidth.vue'
import Requests from '@/views/usage/Requests.vue'
import Concurrencies from '@/views/usage/Concurrencies.vue'

export default [
  {
    name: 'ModuleComs',
    value: [
      { label: i18n.t('usage.bandwidth'), component: Bandwidth, ref: 'BandwidthRef' }, // 业务带宽
      { label: i18n.t('usage.requests'), component: Requests, ref: 'RequestsRef' }, // 请求数
      { label: i18n.t('usage.concurrencies'), component: Concurrencies, ref: 'ConcurrenciesRef' } // 并发数
    ]
  },
  {
    name: 'BusinessType',
    value: [
      { label: i18n.t('usage.websiteBusiness'), value: 2 },
      { label: i18n.t('usage.nonWebsiteBusiness'), value: 3 },
    ]
  },
  {
    name: 'BillingMethodOptions',
    value: [
      { label: i18n.t('usage.billingVal') + i18n.t('common.bracket', { name: i18n.t('usage.total') }), value: 0 }, // 计费值（合计）
      { label: i18n.t('usage.billingVal') + i18n.t('common.bracket', { name: i18n.t('orders.fourthPeak') }), value: 1 }, // 计费值（第四峰值）
      { label: i18n.t('usage.billingVal') + i18n.t('common.bracket', { name: i18n.t('usage.95bandwithVal') }), value: 2 }, // 计费值（95%带宽值）
      { label: i18n.t('usage.billingVal') + i18n.t('common.bracket', { name: i18n.t('orders.firstPeak') }), value: 3 }, // 计费值（第一峰值）
      { label: i18n.t('usage.billingVal') + i18n.t('common.bracket', { name: i18n.t('orders.peakAverage') }), value: 4 } // 计费值（峰值平均）
    ]
  },
]
